import { useEffect, useLayoutEffect } from "react";
import { FilterName, FontsAreLoaded } from "../state/filter";

import { strings } from "@quickpoint.me/shared";
import { throttle } from "../lib/throttle";
import { useRecoilValue } from "recoil";
import { AllLoaded } from "../state/selectors";

const SCROLL_THROTTLE = 100; // ms

function SyncManager() {
	const allLoaded = useRecoilValue(AllLoaded);
	const fontsAreLoaded = useRecoilValue(FontsAreLoaded);
	const filterName = useRecoilValue(FilterName);

	// Effect for sending content height
	useLayoutEffect(() => {
		if (allLoaded && fontsAreLoaded) {
			const timer = setTimeout(() => {
				const scrollContainer = document.querySelector(
					"#scroll-elements-container",
				);
				const height = scrollContainer
					? scrollContainer.scrollHeight
					: document.body.scrollHeight;

				const bc = new BroadcastChannel(strings.broadcastChannel.viewer);
				bc.postMessage({ type: "contentHeight", height: height });
				bc.close();
			}, 100); // Delay to allow content to render fully

			return () => clearTimeout(timer);
		}

		return;
	}, [fontsAreLoaded, filterName, allLoaded]);

	// Effect for sending scroll position
	useEffect(() => {
		const scrollContainer = document.querySelector(
			"#scroll-elements-container",
		);
		if (!scrollContainer) return;

		const handleScroll = (e: Event) => {
			const target = e.target as HTMLElement;
			const bc = new BroadcastChannel(strings.broadcastChannel.viewer);
			bc.postMessage({ type: "scrollSync", scrollTop: target.scrollTop });
			bc.close();
		};

		const throttledScroll = throttle(handleScroll, SCROLL_THROTTLE);

		scrollContainer.addEventListener("scroll", throttledScroll);

		return () => {
			scrollContainer.removeEventListener("scroll", throttledScroll);
			throttledScroll.cancel();
		};
	}, [allLoaded, filterName]); // Re-attach listener if container changes

	return null;
}

export default SyncManager;
